import { Component, OnInit } from '@angular/core';
import {
  HttpClient,
  HttpResponse,
  HttpParams,
  HttpHeaders,
} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
declare var $;

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent implements OnInit {
  url = environment.api_url;
  userObj = {
    emailId: '',
    password: '',
    confirmPassword: '',
  };
  code;
  display = 'none';
  user_bot;
  isDisable = false;
  showble = false;
  confishowble = false;
  user_bot1: boolean;
  errorMessage = '';
  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {
    this.showble = false;
    this.confishowble = false;
  }

  ngOnInit() {
    this.showble = false;
    this.confishowble = false;
    this.code = this.route.snapshot.queryParamMap.get('code');
    const body = new HttpParams().append('code', this.code);
    this.http
      .get(this.url + '/resetUser', { params: body })
      .subscribe((res: any) => {
        const result = res;
        this.showble = false;
        this.confishowble = false;
        if (result && result.statusCode === '001') {
          this.userObj.emailId = result.emailId;
        }
      });

    this.showble = false;
    this.confishowble = false;
  }

  onKeyUp(event: any) {
    let pass = event.target.value;

    if (pass != undefined && pass != '') {
      this.showble = true;
    } else if (pass == '') {
      this.showble = false;
    }
  }

  onKeyUpconfirm(event: any) {
    let confpass = event.target.value;

    if (confpass != undefined && confpass != '') {
      this.confishowble = true;
    } else {
      this.confishowble = false;
    }
  }

  validatePassword() {
    if (this.userObj.password !== this.userObj.confirmPassword) {
      this.errorMessage = 'Password Mismatch';
      this.userObj.confirmPassword = '';
    } else {
      this.errorMessage = '';
    }
  }

  login(event, myForm) {
    this.openModal();
    const body = new HttpParams()
      .append('code', this.code)
      .append('password', this.userObj.password)
      .append('emailId', this.userObj.emailId);

    this.http
      .get(this.url + '/reset/password', { params: body })
      .subscribe((res: any) => {
        this.onCloseHandled();
        const result = res;
        if (result.statusCode && result.statusCode === '002') {
        } else {
          $('#pswdResetModal').modal('show');
          myForm.resetForm();
          setTimeout(() => {
            $('#pswdResetModal').modal('hide');
            this.router.navigate(['login']);
          }, 1000);
        }
      });
  }
  closebtn() {
    window.history.back();
  }
  // to open the modal
  openModal() {
    this.display = 'block';
  }
  // to close the modal
  onCloseHandled() {
    this.display = 'none';
  }
  toggleShowPassword(password) {
    this.user_bot = !this.user_bot;
  }
  toggleConfirmPassword(password) {
    this.user_bot1 = !this.user_bot1;
  }
}
